import React from "react";
import edit_pencil_icon from "../../assets/icons/edit_pencil_icon.png";
import attachment_pin_icon from "../../assets/icons/attachment_pin_icon.png";
import cross_icon from "../../assets/icons/cross_icon.png";

const EmailModal = ({
  closeModal,
  setShowModal,
  setShowTaskCompleted,
  setShowRescheduledTask,
  setShowEditEmailModal,
}) => {
  const handleTaskCompleted = () => {
    setShowModal(false);
    setShowTaskCompleted(true);
  };

  const handleRescheduleTask = () => {
    setShowModal(false);
    setShowTaskCompleted(false);
    setShowRescheduledTask(true);
  };

  const handleEditEmailModal = () => {
    setShowEditEmailModal(true);
    closeModal();
  };

  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[30%]">
        <div className="flex justify-center">
          <div className="font-bold text-[20px]">Emailing - Praveen Sharma</div>
          <div
            className="cursor-pointer absolute right-3 top-4"
            onClick={closeModal}
          >
            <img src={cross_icon} alt="cross icon"/>
          </div>
        </div>
        <div className="flex flex-col border p-4 rounded-lg mt-6">
          <div className="flex justify-between">
            <div className="text-[14px] font-bold">Email invite template</div>
            <div className="cursor-pointer" onClick={handleEditEmailModal}>
              <img src={edit_pencil_icon} alt="edit pencil"/>
            </div>
          </div>
          <div className="my-2 text-[12px]">
            Hope you are doing well. This email is...
          </div>
          <div className="flex items-center">
            <div>
              <img src={attachment_pin_icon} alt="attachments"/>
            </div>
            <div className="ml-2">Attach for invite</div>
          </div>
        </div>
        <div className="mt-5">Add Comment/Notes</div>
        <div>
          <input
            placeholder="Enter the comment"
            className="border border-[#95C2FF] w-full rounded-lg p-2"
          />
        </div>
        <div className="flex justify-between mt-5">
          <button
            className="w-6/12 bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className="w-6/12 bg-[#2F80ED] ml-2 p-2 text-white rounded-lg"
            onClick={handleTaskCompleted}
          >
            Send
          </button>
        </div>
        <div className="flex justify-center mt-6 text-[#2F80ED] font-bold underline">
          <div className="cursor-pointer" onClick={handleRescheduleTask}>
            Reschedule Task
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailModal;
